import { createTheme } from '@mui/material/styles';
import { snackbarAnchorOrigin } from '../constants/snackbarAnchor';

/**
 * Shared MUI theme for the root `ThemeProvider` and Toolpad `AppProvider` on
 * **BusinessDashboard** and **ServiceDashboard** (each supplies its own `ThemeProvider`
 * and does not inherit the root context).
 */
/** Body text; headings set 'Plus Jakarta Sans'. Both load from Google Fonts in public/index.html. */
const BODY_FONT = "'DM Sans', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif";

export const appTheme = createTheme({
  typography: {
    fontFamily: BODY_FONT,
  },
  components: {
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: snackbarAnchorOrigin,
        autoHideDuration: 6000,
      },
    },
  },
});
